var T = /* @__PURE__ */ ((E) => (E.LEFT = "left", E.RIGHT = "right", E.SPACE_BETWEEN = "space-between", E))(T || {}), r = /* @__PURE__ */ ((E) => (E.TOP = "top", E.MIDDLE = "middle", E.BOTTOM = "bottom", E))(r || {});
export {
  T as RocheUISideBySideHorizontalAlignment,
  r as RocheUISideBySideVerticalAlignment
};
